module.exports = "<!--Show Spinner on value true-->\n    <div class=\"preloader_content\" *ngIf=\"loadSpinner\">\n   \t<div class=\"mpreloader-div\">\n<div class=\"loadder\"></div>\n<div class=\"preloader_logo\"><img src=\"../../../assets/images/spinner-logo.png\"  class=\"responsive\"></div>\n</div></div>\n    <app-header *ngIf=\"loadHeader\" ></app-header>\n    <router-outlet></router-outlet>\n    <app-footer></app-footer>\n    "


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main